/* eslint-disable no-param-reassign */
import { layoutEach } from '@/utils/layout';
import { FIELD_TYPE, PRIMARY_KEY_TYPE } from '@tencent/wuji-utils';
export function hideFormItemIfNeeded(layout, rootStub, sourceStub) {
    if (!sourceStub) {
        return;
    }
    const source = sourceStub.value;
    // console.log('source', source);
    // // 只处理db数据源， er数据源处理了一对一的场景
    if (source && (source?.stateModel !== 'form_JS' || !['db', 'er'].includes(source?.collection?.collectionData?.type))) {
        return;
    }
    // @ts-ignore
    if (!source && !sourceStub.schema?.['ds:model_form_js']) {
        // 弹窗的特殊推导
        return;
    }
    const entity = source?.getEntitySchema() || sourceStub.getChildStub('formData')?.schema;
    ;
    const primaryKey = getPrimaryKey(entity);
    const renderCondition = primaryKey ? `${sourceStub.path}.formData.${primaryKey}` : '';
    layoutEach(layout, (item) => {
        if (item.type === 'w-form-item') { // 一般是表单推导的
            const input = item.children?.[0];
            const bindingPath = input?.bindings?.['v-model']; // todo list作用域
            if (bindingPath && !bindingPath?.startsWith('data.item.')) {
                const subStub = rootStub.getStubAtPath(bindingPath);
                if (subStub) {
                    const fieldSchema = subStub.schema;
                    if (fieldSchema && isHideNeeded(fieldSchema)) {
                        if (renderCondition) {
                            item.renderCondition = renderCondition;
                        }
                        if (!input.type.includes('readonly')) {
                            item.props = item.props || {};
                            item.props.readonly = true;
                            item.props.disabled = true;
                        }
                    }
                }
            }
        }
        if (item.type === 'w-list-2v') {
            // todo 一对多list作用域
        }
    });
}
export function isHideNeeded(schema) {
    // 自定义ID允许写
    if (PRIMARY_KEY_TYPE.ID === schema.ui?.settings?.type) {
        return false;
    }
    // @ts-ignore
    return schema['ds:dbBuildInField'] || [
        FIELD_TYPE.CTIME,
        FIELD_TYPE.MTIME,
        FIELD_TYPE.CREATOR,
        FIELD_TYPE.MODIFIER,
        PRIMARY_KEY_TYPE.DEFAULT_ID,
        PRIMARY_KEY_TYPE.RANDOM_ID,
        PRIMARY_KEY_TYPE.INCREASE_ID,
        PRIMARY_KEY_TYPE.NUM_INCREASE_ID,
    ].includes(schema.ui?.settings?.type);
}
export function getPrimaryKey(schema) {
    if (!schema?.fields)
        return;
    const target = schema.fields?.find(item => item?.isPrimaryKey);
    return target?.id;
}
